import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 's18-select-date-dialog',
  templateUrl: './select-date-dialog.component.html',
  styleUrls: ['./select-date-dialog.component.scss']
})
export class SelectDateDialogComponent implements OnInit {

  date: string = "";

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SelectDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onCancel(){
    this.dialog.closeAll();
  }

  onOk(){
    var formattedDate = new Date(this.date);
    console.log(formattedDate);
    console.log(formattedDate.toISOString());
    this.dialogRef.close(formattedDate.toISOString());
  }

}
